import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from '@redux-saga/core';

import SystemReducer from './slices/system/system.slice';
import PartyReducer from './slices/party/party.slice';
import ChatReducer from './slices/chat/chat.slice';
import ProductReducer from './slices/product/product.slice';
import ContractReducer from './slices/contract/contract.slice';
import ProductManagementReducer from './slices/admin/product-management/product-management.slice';
import EventReducer from './slices/event/event.slice';
import DealRoomManagementReducer from './slices/admin/deal-room-management/deal-room-management.slice';
import AccountManagementReducer from './slices/admin/account-management/account-management.slice';
import MarketBuzzReducer from './slices/market-buzz/market-buzz.slice';
import DashboardReducer from './slices/dashboard/dashboard.slice';
import UserReducer from './slices/user/user.slice';
import EWalletReducer from './slices/e-wallet/e-wallet.slice';
import HelpCenterReducer from './slices/help-center/help-center.slice';
import UserRoleManagementReducer from './slices/admin/user-role-management/user-role-management.slice';
import ReportReducer from './slices/report/report.slice';
import CurrencyReducer from './slices/currency/currency.slice';

import loginSaga from './api/login/login.saga';
import partySaga from './api/party/party.saga';
import chatSaga from './api/chat/chat.saga';
import productSaga from './api/product/product.saga';
import socialLoginSaga from './api/social-login/social-login.saga';
import registrationSaga from './api/registration/registration.saga';
import verificationSaga from './api/verification/verification.saga';
import contractSaga from './api/contract/contract.saga';
import documentSaga from './api/document/document.saga';
import adminProductSaga from './api/admin/product/admin-product.saga';
import eventSaga from './api/event/event.saga';
import adminAccountSaga from './api/admin/account/admin-account.saga';
import notificationSaga from './api/notification/notification.saga';
import marketBuzzSaga from './api/market-buzz/market-buzz.saga';
import systemUserSaga from './api/system-user/system-user.saga';
import eWalletSaga from './api/e-wallet/e-wallet.saga';
import adminUserRoleManagementSaga from './api/admin/user-role/admin-user-role.saga';
import helpSaga from './api/help/help.saga';
import reportSaga from './api/report/report.saga';
import currencyCodeSaga from './api/currency-code/currency-code.saga';
import preferenceSaga from './api/preference/preference.saga';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    system: SystemReducer,
    party: PartyReducer,
    chat: ChatReducer,
    product: ProductReducer,
    contract: ContractReducer,
    productManagement: ProductManagementReducer,
    event: EventReducer,
    dealRoomManagement: DealRoomManagementReducer,
    accountManagement: AccountManagementReducer,
    marketBuzz: MarketBuzzReducer,
    dashboard: DashboardReducer,
    user: UserReducer,
    eWallet: EWalletReducer,
    helpCenter: HelpCenterReducer,
    userRoleManagement: UserRoleManagementReducer,
    report: ReportReducer,
    currency: CurrencyReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(loginSaga);
sagaMiddleware.run(partySaga);
sagaMiddleware.run(chatSaga);
sagaMiddleware.run(productSaga);
sagaMiddleware.run(verificationSaga);
sagaMiddleware.run(contractSaga);
sagaMiddleware.run(documentSaga);
sagaMiddleware.run(socialLoginSaga);
sagaMiddleware.run(registrationSaga);
sagaMiddleware.run(adminProductSaga);
sagaMiddleware.run(eventSaga);
sagaMiddleware.run(adminAccountSaga);
sagaMiddleware.run(notificationSaga);
sagaMiddleware.run(marketBuzzSaga);
sagaMiddleware.run(systemUserSaga);
sagaMiddleware.run(eWalletSaga);
sagaMiddleware.run(adminUserRoleManagementSaga);
sagaMiddleware.run(helpSaga);
sagaMiddleware.run(reportSaga);
sagaMiddleware.run(currencyCodeSaga);
sagaMiddleware.run(preferenceSaga);
